import React, { useEffect, useState } from 'react';
import Compressor from 'compressorjs';
import axios from 'axios';

const useCoverChange = (file = null, upKey = null, delKey = null) => {
  const [coverProgress, setCoverProgress] = useState(0);
  const [coverUrl, setCoverUrl] = useState('');
  const [coverKey, setCoverKey] = useState('');

  // Delete from backend
  useEffect(() => {
    if (delKey) {
      const handleDelete = async () => {
        try {
          console.log('Deleting file with key:', delKey);
          await axios.post('/api/delete-image', { key: delKey });
          console.log('Cover picture deleted:', delKey);
          setCoverUrl('');
          setCoverKey('');
        } catch (err) {
          console.error('Failed to delete cover picture:', err);
        }
      };
      handleDelete();
    }
  }, [delKey]);

  // Upload cover picture via backend
  useEffect(() => {
    if (!file) return;

    console.log('Starting upload with file:', file);

    new Compressor(file, {
      quality: 0.7,
      maxWidth: 1200,
      maxHeight: 400,
      success: async (compressedFile) => {
        console.log('Compression successful, uploading...');
        const fData = new FormData();
        fData.append('image', compressedFile);
        fData.append('filePath', upKey + '/');
        fData.append('content_type', compressedFile.type);

        try {
          console.log('Making API request to /api/upload-image');
          const response = await axios.post('/api/upload-image', fData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
            onUploadProgress: (evt) => {
              const progressPercentage = Math.round(
                (evt.loaded * 100) / evt.total
              );
              console.log('Upload progress:', progressPercentage);
              setCoverProgress(progressPercentage);
            },
          });

          console.log('Upload response:', response.data);
          if (response?.data?.url) {
            setCoverUrl(response.data.url);
            setCoverKey(response.data.Key);
            setCoverProgress(100);
          }
        } catch (err) {
          console.error('Cover picture upload failed:', err.response?.data || err.message);
          setCoverProgress(0);
        }
      },
      error: (err) => {
        console.error('Cover picture compression failed:', err);
        setCoverProgress(0);
      },
    });
  }, [file, upKey]);

  return [coverUrl, coverKey, coverProgress];
};

export default useCoverChange;